<form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="row">
        <div class="form-group col-md-6">
            <validation [formGroup]="form" controlName="businessDisplayName" displayName="Display name">
                <label for="businessDisplayName">
                    <h3>Business Display Name: <i class="pi pi-question-circle tooltip-icon"
                                                  pTooltip="{{getBusinessDisplayNameTooltip()}}"></i>
                    </h3>
                </label> <input class="form-control"
                                formControlName="businessDisplayName"
                                id="businessDisplayName"
                                placeholder=""
                                type="text"/>
            </validation>
        </div>

        <div class="form-group col-md-6">
            <validation [formGroup]="form" controlName="businessType" displayName="Business type">
                <label for="business-type"><h3>Business Type:</h3></label>
                <p-select [options]="businessTypeList"
                          class="form-control"
                          formControlName="businessType"
                          id="business-type"
                          optionLabel="label"
                          optionValue="value"
                          placeholder="Select your business type"/>
            </validation>
        </div>
    </div>

    <div class="row">
        <div class="form-group col-md-6">
            <validation [formGroup]="form" controlName="clientBase" displayName="Current client base">
                <label for="clientBase"><h3>Current Client Base:</h3></label>
                <p-select [options]="clientBaseList"
                          class="form-control"
                          formControlName="clientBase"
                          id="clientBase"
                          optionLabel="value"
                          optionValue="value"
                          placeholder="-- Please select --"/>
            </validation>
        </div>
        <div class="form-group col-md-6">
            <validation [formGroup]="form" controlName="averageTransactionValue"
                        displayName="Average transaction amount">
                <label for="averageTransactionAmount"><h3>Average Transaction Amount:</h3></label>
                <p-select [options]="averageTransactionValueList"
                          class="form-control"
                          formControlName="averageTransactionValue"
                          id="averageTransactionAmount"
                          optionLabel="value"
                          optionValue="value"
                          placeholder="-- Please select --"/>
            </validation>
        </div>
    </div>

    <div class="row justify-content-center justify-content-sm-center">
        <div class="btn-group mt-5">
            <button class="navy-btn" type="submit">
                Next <i class="fa fa-chevron-right fas"></i>
            </button>
        </div>
    </div>

</form>
<pre [hidden]="!isDeveloperMode()"><code>{{ getAllErrors(form) | json }}</code></pre>
